import { render, staticRenderFns } from "./game-list-page.vue?vue&type=template&id=379eee2d&"
import script from "./game-list-page.vue?vue&type=script&lang=js&"
export * from "./game-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports